const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

// Escapa texto antes de interpolar em HTML montado à mão (ex.: PDFs abertos com document.write).
// Sem isso, um campo com "<script>" ou "<img onerror>" vira código rodando na origem do sistema.
export const escapeHtml = (value) =>
  String(value ?? '').replace(/[&<>"']/g, (char) => HTML_ESCAPES[char]);
